export default {
  tiles: [
    {
      id: 1,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      imageAlt: '',
      nerdName: 'Luis',
      nerdTitle: 'Product Analytics Nerd',
      darkBackground: true,
      nerdDescription:
        "Having joined as a remote Nerd, I wasn't sure what it would be like to work with teams I'd never met in person. But through fun and interactive Slack channels, thematic happy hours, and inclusive team meetings, I've never felt out of place. We all belong here.",
    },
    {
      id: 2,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/mobile/Carousel-Image-Mobile-01-v2.jpg',
      imageAlt: 'meet-nerds-image-1',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 3,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      imageAlt: '',
      nerdName: 'Rachel',
      nerdTitle: 'People Operations Nerd',
      darkBackground: true,
      nerdDescription:
        "I'm thankful to work at a company that supports me as an employee and as a parent. From flexible scheduling so that I can pick up my daughter from school to designated company-wide Mental Health Days, to generous parental leave, NerdWallet allows me to bring my whole self.",
    },
    {
      id: 4,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-02-sfw.jpg',
      imageAlt: 'meet-nerds-image-2',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 5,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      imageAlt: '',
      nerdName: 'Hass',
      nerdTitle: 'Product Design Nerd',
      darkBackground: true,
      nerdDescription:
        'Being at NerdWallet creates so many opportunities for cross-functional collaboration! Nerds are encouraged to reach out well beyond their primary teams to tackle challenges in delivering nerdy expertise to our appreciative users.',
    },
    {
      id: 6,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-03-sfw.jpg',
      imageAlt: 'meet-nerds-image-3',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 7,
      isImage: false,
      darkBackground: true,
      imageUrl: '',
      imageUrlMobile: '',
      imageAlt: '',
      nerdName: 'Kimra',
      nerdTitle: 'User Experience Nerd',
      nerdDescription:
        "A lot of companies say they're consumer-first, but I've never had a workplace strive to put real people front and center quite like NerdWallet. It's clear Nerds care deeply about the humans we serve.",
    },
    {
      id: 8,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-04-sfw.jpg',
      imageAlt: 'meet-nerds-image-4',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 9,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      darkBackground: true,
      imageAlt: '',
      nerdName: 'Jon',
      nerdTitle: 'Brand Studio Nerd',
      nerdDescription:
        'Curiosity is a powerful thing, and it’s what excites me about coming to work every day. NerdWallet has built a culture of openness and willingness to challenge our own assumptions and status quo — giving everyone more opportunity to be creative, collaborative, and impactful.',
    },
    {
      id: 10,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-05-sfw.jpg',
      imageAlt: 'meet-nerds-image-4',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 11,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      darkBackground: true,
      imageAlt: '',
      nerdName: 'Gerard',
      nerdTitle: 'Performance Marketing Nerd',
      nerdDescription:
        "“NerdWallet has provided me the freedom to be my full self in the workplace, and that commitment to its employees' full self has attracted a diverse array of hard-working, talented coworkers.",
    },
    {
      id: 12,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-06-sfw.jpg',
      imageAlt: 'meet-nerds-image-4',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 13,
      isImage: false,
      imageUrl: '',
      imageUrlMobile: '',
      darkBackground: true,
      imageAlt: '',
      nerdName: 'Sharadh',
      nerdTitle: 'Engineering Nerd',
      nerdDescription:
        "Every day I've worked here, I've had the privilege of engaging with smart and just plain nice people. Everyone is committed to learning and growing, and is gracious with time and support.",
    },
    {
      id: 12,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2023/nerd-carousel/mobile/Careers-Carousel-07-sfw.jpg',
      imageAlt: 'meet-nerds-image-4',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
    {
      id: 13,
      isImage: false,
      darkBackground: true,
      imageUrl: '',
      imageUrlMobile: '',
      imageAlt: '',
      nerdName: 'Yuri',
      nerdTitle: 'Product Management Nerd',
      nerdDescription:
        "You're given a lot of ownership from the beginning. It may be frightening at the start, but you are surrounded with brilliant colleagues who are rooting for your success. You are able to flex your strengths here and as a team, make an impact for NerdWallet’s customers.",
    },
    {
      id: 14,
      isImage: true,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/nerd-carousel/final/mobile/Carousel-Image-Mobile-08-v2.jpg',
      imageAlt: 'meet-nerds-image-4',
      nerdName: '',
      nerdTitle: '',
      nerdDescription: '',
    },
  ],
};
